import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["thumbnail", "iframe"]
  static values = { videoId: String, autoplay: { type: Boolean, default: true } }

  play() {
    const iframe = document.createElement("iframe")
    const autoplay = this.autoplayValue ? "?autoplay=1" : ""
    iframe.src = `https://www.youtube-nocookie.com/embed/${this.videoIdValue}${autoplay}`
    iframe.setAttribute("allowfullscreen", "")
    iframe.setAttribute("allow", "autoplay; encrypted-media")
    iframe.classList.add("w-full", "h-full", "absolute", "inset-0")

    this.thumbnailTarget.classList.add("hidden")
    this.iframeTarget.classList.remove("hidden")
    this.iframeTarget.appendChild(iframe)
  }

  disconnect() {
    const iframe = this.iframeTarget.querySelector("iframe")
    if (iframe) iframe.remove()
  }
}
